// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3USAB","topBottomGutter":"Layout_topBottomGutter__1AtCi"};